<!--
/**
 * @fileoverview Days highlight component
 * @license MIT
 * @author Rafal Pospiech <neuronet.io@gmail.com>
 * @package GanttElastic
 */
-->

<template>
  <g>
    <rect
      v-for="(day, index) in days"
      :key="index"
      class="gantt-elastic__chart-days-highlight-rect"
      :x="day.offset.px"
      :y="task.y - root.state.options.chart.grid.horizontal.gap"
      :width="day.width.px"
      :height="task.height + root.state.options.chart.grid.horizontal.gap"
      :style="{ ...root.style['chart-day-hilghlight-rect'] }"
    />

    <line
      v-for="(day, index) in days"
      :key="'startLine' + index"
      :x1="day.offset.px"
      :y1="task.y - root.state.options.chart.grid.horizontal.gap + 1"
      :x2="day.offset.px"
      :y2="task.y + task.height + root.state.options.chart.grid.horizontal.gap"
      style="stroke: #f0f0f0; stroke-width: 1;"
    />

    <line
      v-for="(day, index) in days"
      :key="'endLine:' + index"
      :x1="day.offset.px + day.width.px"
      :y1="task.y - root.state.options.chart.grid.horizontal.gap + 1"
      :x2="day.offset.px + day.width.px"
      :y2="task.y + task.height + root.state.options.chart.grid.horizontal.gap"
      style="stroke: #f0f0f0; stroke-width: 1;"
    />
  </g>
</template>

<script>
import dayjs from 'dayjs';
export default {
  name: 'DaysHighlight',
  inject: ['root'],
  props: ['task', 'days'],
};
</script>
